import { NavItemEnum } from '../routing/NavItems';
import { ENTERPRISE, STARTER } from '../routing/Tabs';
const CaseStudiesConfig = {
  [NavItemEnum.MARKETING]: {
    [STARTER]: [{
      caseStudyKey: 'canceriq',
      href: 'https://www.hubspot.com/case-studies/canceriq',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/1_S8CLgCauap79DEu6IXL0Hg.png'
    }, {
      caseStudyKey: 'checkwriters',
      href: 'https://www.hubspot.com/case-studies/checkwriters',
      logo: 'https://www.hubspot.com/hubfs/logo-Oct-16-2023-03-44-38-0708-PM.svg'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'fundraise-up',
      href: 'https://www.hubspot.com/case-studies/fundraise-up',
      logo: 'https://www.hubspot.com/hubfs/Fundraise%20Up%20Logo%20(Color%2c%20Hor).svg'
    }, {
      caseStudyKey: 'loom',
      href: 'https://www.hubspot.com/case-studies/loom',
      logo: 'https://www.hubspot.com/hubfs/Loom-Logo.png'
    }]
  },
  [NavItemEnum.SALES]: {
    [STARTER]: [{
      caseStudyKey: 'ceros',
      href: 'https://www.hubspot.com/case-studies/ceros',
      logo: 'https://53.fs1.hubspotusercontent-na1.net/hubfs/53/Case_Studies/Ceros/Ceros_Digital_Magazine.png'
    }, {
      caseStudyKey: 'australian-training-colleges',
      href: 'https://www.hubspot.com/case-studies/australian-training-colleges',
      logo: 'https://www.hubspot.com/hubfs/_logo%20(500%20x%20250%20px).png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'teamwork',
      href: 'https://www.hubspot.com/case-studies/teamwork.com',
      logo: 'https://www.hubspot.com/hubfs/1200px-Teamwork-logo.svg-1.png'
    }, {
      caseStudyKey: 'm-square-media',
      href: 'https://www.hubspot.com/case-studies/m-square-media',
      logo: 'https://www.hubspot.com/hubfs/MSM%20Logo.png'
    }]
  },
  [NavItemEnum.SERVICE]: {
    [STARTER]: [{
      caseStudyKey: 'swapfiets',
      href: 'https://www.hubspot.com/case-studies/swapfiets',
      logo: 'https://knowledge.hubspot.com/hubfs/358201-Swapfiets_logos_RGB_Blue-1c3aa0-original-1593634730.png'
    }, {
      caseStudyKey: 'sunsail-and-the-moorings',
      href: 'https://www.hubspot.com/case-studies/sunsail-and-the-moorings',
      logo: 'https://www.hubspot.com/hubfs/SS-TM_logos.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'swapfiets',
      href: 'https://www.hubspot.com/case-studies/swapfiets',
      logo: 'https://knowledge.hubspot.com/hubfs/358201-Swapfiets_logos_RGB_Blue-1c3aa0-original-1593634730.png'
    }, {
      caseStudyKey: 'sunsail-and-the-moorings',
      href: 'https://www.hubspot.com/case-studies/sunsail-and-the-moorings',
      logo: 'https://www.hubspot.com/hubfs/SS-TM_logos.png'
    }]
  },
  [NavItemEnum.CONTENT]: {
    [STARTER]: [{
      caseStudyKey: 'kuntze',
      href: 'https://www.hubspot.com/case-studies/kuntze',
      logo: 'https://www.kuntzeusa.com/hubfs/Kuntze_August2019/Image/logo.svg'
    }, {
      caseStudyKey: 'classpass',
      href: 'https://www.hubspot.com/case-studies/classpass',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/ClassPass%20Logo.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'rocket-content',
      href: 'https://www.hubspot.com/case-studies/rock-content',
      logo: 'https://www.hubspot.com/hubfs/rock%20content%20logo.png'
    }, {
      caseStudyKey: 'rankmi',
      href: 'https://www.hubspot.com/case-studies/rankmi',
      logo: 'https://53.fs1.hubspotusercontent-na1.net/hubfs/53/Rankmi.png'
    }]
  },
  [NavItemEnum.OPERATIONS]: {
    [STARTER]: [{
      caseStudyKey: 'askcody',
      href: 'https://www.hubspot.com/case-studies/askcody',
      logo: 'https://www.askcody.com/hubfs/AskCody%20Optimized%20images/askcody-logo.png'
    }, {
      caseStudyKey: 'thomas-witt-consulting',
      href: 'https://www.hubspot.com/case-studies/thomas-witt-consulting',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/Thomas%20Witt%20Consulting%20Logo.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'casio',
      href: 'https://www.hubspot.com/case-studies/casio',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Casio.png'
    }, {
      caseStudyKey: 'suzuki',
      href: 'https://www.hubspot.com/case-studies/suzuki',
      logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/Suzuki%20Logo.png'
    }]
  },
  [NavItemEnum.COMMERCE]: {
    [STARTER]: [{
      caseStudyKey: 'nutritional-coaching-institute-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/nutritional-coaching-institute-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/NCI-3.png'
    }, {
      caseStudyKey: 'apps-without-code-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/apps-without-code-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/AWOC.png'
    }],
    [ENTERPRISE]: [{
      caseStudyKey: 'nutritional-coaching-institute-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/nutritional-coaching-institute-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/NCI-3.png'
    }, {
      caseStudyKey: 'apps-without-code-hubspot-payments',
      href: 'https://www.hubspot.com/case-studies/apps-without-code-hubspot-payments',
      logo: 'https://www.hubspot.com/hubfs/AWOC.png'
    }]
  }
};
export const getCaseStudies = ({
  navItem,
  tab
}) => {
  const configs = CaseStudiesConfig[navItem];
  if (!configs) return [];
  if (!configs[tab]) return [];
  return configs[tab];
};
const SSM0009CaseStudiesConfig = {
  [NavItemEnum.MARKETING]: [{
    caseStudyKey: 'canceriq',
    href: 'https://www.hubspot.com/case-studies/canceriq',
    logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/1_S8CLgCauap79DEu6IXL0Hg.png'
  }, {
    caseStudyKey: 'checkwriters',
    href: 'https://www.hubspot.com/case-studies/checkwriters',
    logo: 'https://www.hubspot.com/hubfs/logo-Oct-16-2023-03-44-38-0708-PM.svg'
  }],
  [NavItemEnum.SALES]: [{
    caseStudyKey: 'ceros',
    href: 'https://www.hubspot.com/case-studies/ceros',
    logo: 'https://53.fs1.hubspotusercontent-na1.net/hubfs/53/Case_Studies/Ceros/Ceros_Digital_Magazine.png'
  }, {
    caseStudyKey: 'australian-training-colleges',
    href: 'https://www.hubspot.com/case-studies/australian-training-colleges',
    logo: 'https://www.hubspot.com/hubfs/_logo%20(500%20x%20250%20px).png'
  }],
  [NavItemEnum.SERVICE]: [{
    caseStudyKey: 'swapfiets',
    href: 'https://www.hubspot.com/case-studies/swapfiets',
    logo: 'https://knowledge.hubspot.com/hubfs/358201-Swapfiets_logos_RGB_Blue-1c3aa0-original-1593634730.png'
  }, {
    caseStudyKey: 'sunsail-and-the-moorings',
    href: 'https://www.hubspot.com/case-studies/sunsail-and-the-moorings',
    logo: 'https://www.hubspot.com/hubfs/SS-TM_logos.png'
  }],
  [NavItemEnum.CONTENT]: [{
    caseStudyKey: 'kuntze',
    href: 'https://www.hubspot.com/case-studies/kuntze',
    logo: 'https://www.kuntzeusa.com/hubfs/Kuntze_August2019/Image/logo.svg'
  }, {
    caseStudyKey: 'classpass',
    href: 'https://www.hubspot.com/case-studies/classpass',
    logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/ClassPass%20Logo.png'
  }],
  [NavItemEnum.OPERATIONS]: [{
    caseStudyKey: 'askcody',
    href: 'https://www.hubspot.com/case-studies/askcody',
    logo: 'https://www.askcody.com/hubfs/AskCody%20Optimized%20images/askcody-logo.png'
  }, {
    caseStudyKey: 'thomas-witt-consulting',
    href: 'https://www.hubspot.com/case-studies/thomas-witt-consulting',
    logo: 'https://www.hubspot.com/hubfs/Fergals/Case%20Study%20Logos/Thomas%20Witt%20Consulting%20Logo.png'
  }],
  [NavItemEnum.COMMERCE]: [{
    caseStudyKey: 'nutritional-coaching-institute-hubspot-payments',
    href: 'https://www.hubspot.com/case-studies/nutritional-coaching-institute-hubspot-payments',
    logo: 'https://www.hubspot.com/hubfs/NCI-3.png'
  }, {
    caseStudyKey: 'apps-without-code-hubspot-payments',
    href: 'https://www.hubspot.com/case-studies/apps-without-code-hubspot-payments',
    logo: 'https://www.hubspot.com/hubfs/AWOC.png'
  }]
};
export const getSSM0009CaseStudies = ({
  navItem
}) => {
  return SSM0009CaseStudiesConfig[navItem] || [];
};